<template>
  <div class="header_tab" ref="nav">
    <ul class="tab_content">
      <li
        v-for="(item, index) in tabList"
        :key="index"
        @click="up(item)"
        :id="item.id"
        :clstag="`newscenter|keycount|headerTab-pc|click-${item.code}`"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { getHomeList, getUserApi } from '@/api/news'
import { getLang } from '@/utils'
import Cookie from 'js-cookie'
export default {
  components: {},
  data() {
    return {
      tabList: [],
      getLang: getLang(),
      user: false
    }
  },
  computed: {},
  watch: {},
  methods: {
    async getUser() {
      this.user = true
      // const ciftis_at = Cookie.get('ciftis_at')
      // if (ciftis_at) {
      //   const res = await getUserApi({
      //     accountName: Cookie.get('ciftis_account_name')
      //   })
      //   if (res && res.data && res.data.accountType === 'MEDIA')
      //     this.user = true
      // }
    },
    up(item) {
      debugger
      //判断登录态跳转相应路由
      if (window.location.pathname === '/home') {
        if (this.user) {
          if (item.code.includes('Appointment Applications')) {
            window.location.href = '#' + 'Appointment Applications'
          }
          if (item.code.includes('Data Center')) {
            window.location.href = '#' + 'Data Center'
          }
        }
        if (item.code.includes('Media Services')) {
          window.location.href = '#' + 'Media Services'
        }
        if (item.code.includes('Media Center Home')) {
          window.location.href = '#' + 'Media Center Home'
        }
        if (item.code.includes('Focus News')) {
          window.location.href = '#' + 'Focus News'
        }
        if (item.code.includes('Proceedings')) {
          window.location.href = '#' + 'Proceedings'
        }
      }
      if (item.code.includes('News Trends')) {
        this.$router.push({
          path: '/notice',
          query: {
            code: 'News Trends'
          }
        })
        return
      }
      if (item.code.includes('Event Agenda') && this.user) {
        window.location.href = item.url
        return
      } else {
        this.$router.push({
          path: '/web/login'
        })
      }
      if (
        item.code.includes('Media Services') &&
        ['Media Services', 'Media Services1'].includes(item.code)
      ) {
        this.$router.push({
          path: '/home',
          query: {
            tabCode: 'Media Services'
          }
        })
        return
      }

      if (
        item.code.includes('Proceedings') &&
        ['Proceedings', 'Proceedings1'].includes(item.code)
      ) {
        this.$router.push({
          path: '/home',
          query: {
            tabCode: 'Proceedings'
          }
        })
        return
      }
      if (item.code.includes('Media Center Home')) {
        this.$router.push({ path: '/home' })
        return
      }
      if (item.code.includes('Focus News')) {
        this.$router.push({ path: '/home' })
        return
      }
      if (this.user) {
        let lang = Cookie.get('ciftis_site_lang')
        let code = lang === 'en-US' ? item.name : item.code
        if (
          item.code.includes('Appointment Applications') ||
          (item.code.includes('Data Center') &&
            [
              'Appointment Applications',
              'Data Center',
              'Appointment Applications1',
              'Data Center1'
            ].includes(item.code))
        ) {
          this.$router.push({
            path: '/home',
            query: {
              tabCode: code
            }
          })
          return
        }
        if (item.code.includes('Latest Notice')) {
          this.$router.push({
            path: '/cover',
            query: {
              code: code
            }
          })
          return
        }
      } else {
        this.$router.push({
          path: '/web/login'
        })
      }
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop // 滚动条偏移量
      // let middle = (document.documentElement.clientHeight - 230) / 2
      // if (this.$refs.layer) {
      //   if (785 - scrollTop <= middle) {
      //     this.$refs.layer.style = 'position:fixed;top:' + middle + 'px'
      //   } else {
      //     this.$refs.layer.style = 'position:absolute;top:785px'
      //   }
      // }
      if (this.$refs.nav) {
        if (scrollTop > 100) {
          this.$refs.nav.style = 'position:fixed;top:0;z-index:999;'
        } else {
          this.$refs.nav.style = ''
        }
      }
    }
  },
  created() {
    this.getUser()
    window.addEventListener('scroll', this.handleScroll)
  },
  async mounted() {
    const res = await getHomeList()
    this.tabList = res.result.data
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
}
</script>
<style scoped lang="scss">
.header_tab {
  width: 100%;
  height: 50px;
  background: linear-gradient(90deg, #fe8c01 0%, #ff6900 100%);
}
.tab_content {
  width: 1200px;
  height: 100%;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  li {
    width: auto;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    margin-right: 10px;
    padding: 0 20px;
    color: #fff;
    overflow: hidden;
  }
  li:hover {
    background: #ff9d26;
    cursor: pointer;
  }
}
</style>
